export default {
  title: {
    id: 'bo_sellers-orders-drawers-cancel_order-modal_title',
    defaultMessage: 'Cancel order',
  },
  prompt: {
    id: 'bo_sellers-orders-drawers-cancel_order-info_message',
    defaultMessage:
      'Are you sur you want to cancel {sku} from order {orderId}?',
  },
  message: {
    id: 'bo_sellers-orders-drawers-cancel_order-message_to_customer',
    defaultMessage: 'Your message to your customer',
  },
  confirm: {
    id: 'bo_sellers-orders-drawers-cancel_order-cancel_order',
    defaultMessage: 'Yes, cancel this order',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-cancel_order-keep_order',
    defaultMessage: 'No, keep this order',
  },
  successMessage: {
    id: 'bo_sellers-orders-drawers-cancel_order-order_cancelled',
    defaultMessage: 'Order cancelled',
  },
  required: {
    id: 'bo_sellers-orders-drawers-cancel_order-required',
    defaultMessage: 'This field is required',
  },
  loading: {
    id: 'bo_sellers.orders.drawers.cancel_order.loading',
    defaultMessage: 'Fetching order details...',
  },
} as const
